import { Button } from '@chakra-ui/react'

type PropsStatus = {
    status: 'DISPONIVEL' | 'FALHA' | 'INDISPONIVEL'
}

export function Status({ status }: PropsStatus) {
    const optionsStatus = {
        DISPONIVEL: {
            color: 'gray',
            label: 'Disponível'
        },
        FALHA: {
            color: 'red',
            label: 'Falha'
        },
        INDISPONIVEL: {
            color: 'primary',
            label: 'Utilizado'
        }
    }

    const colorStatus = optionsStatus[status]?.color
    const labelStatus = optionsStatus[status]?.label

    return (
        <Button
            _hover={{}}
            colorScheme={colorStatus}
            style={{ cursor: 'initial', width: '120px' }}
        >
            {labelStatus}
        </Button>
    )
}
